import { formatValue } from '@/shared/lib/formatters';
import { ShipmentAttachmentListItem, ShipmentStatus } from '../api/types';

const shipmentAttachmentUrlRefreshThresholdMs = 2 * 60 * 1000;
const supplierQrActionShipmentStatuses = ['ACCEPTED'] satisfies ShipmentStatus[];

export type ShipmentAttachmentType =
  | 'CASE_REPORT_PDF'
  | 'COMMERCIAL_PROPOSAL_PDF'
  | 'SUPPLIER_DELIVERY_PERMIT_PDF';

export const supplierDeliveryPermitAttachmentDisplayName = 'QR для поставщика.pdf';
export const supplierDeliveryPermitAttachmentType = 'SUPPLIER_DELIVERY_PERMIT_PDF' satisfies ShipmentAttachmentType;

export const shipmentPreparationAttachmentTypes = [
  'COMMERCIAL_PROPOSAL_PDF',
  'CASE_REPORT_PDF'
] satisfies ShipmentAttachmentType[];

export const getSupplierDeliveryPermitAttachment = (
  attachments: ShipmentAttachmentListItem[] | null | undefined
): ShipmentAttachmentListItem | null => {
  return attachments?.find((attachment) => (
    attachment.group === 'TRANSPORT' &&
    attachment.source === 'Core' &&
    attachment.type === supplierDeliveryPermitAttachmentType
  )) ?? null;
};

export const canShowSupplierQrAction = (status: ShipmentStatus | string | null | undefined): boolean => {
  if (!status) return false;

  return supplierQrActionShipmentStatuses.some((shipmentStatus) => shipmentStatus === status);
};

export const getShipmentAttachmentDisplayName = (attachment: ShipmentAttachmentListItem): string => {
  if (attachment.type === supplierDeliveryPermitAttachmentType) return supplierDeliveryPermitAttachmentDisplayName;

  return formatValue({ value: attachment.name });
};

export const isShipmentAttachmentUrlRefreshRequired = (attachment: ShipmentAttachmentListItem): boolean => {
  const expiresAtTime = new Date(attachment.expires_at).getTime();

  if (Number.isNaN(expiresAtTime)) return true;

  return expiresAtTime - Date.now() <= shipmentAttachmentUrlRefreshThresholdMs;
};